import { Injectable, Optional } from '@angular/core';

export class CatalogConfigServiceOption {
  options?: any;
  routingBaseUri?: string;
  themingClassName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CatalogConfigService {
  private _options = null;
  private _routingBaseUri = '';
  private _themingClassName = '';

  public get routingBaseUri(): string {
    return this._routingBaseUri.toString();
  }
  public set routingBaseUri(value: string) {
    this._routingBaseUri = value;
  }
  public get themingClassName(): string {
    return this._themingClassName;
  }

  constructor(@Optional() config: CatalogConfigServiceOption) {
    if (config) {
      this._options = config.options || null;
      this._routingBaseUri = config.routingBaseUri || '';
      this._themingClassName = config.themingClassName || '';
    }
  }

  setOptions(value) {
    this._options = value;
  }

  getOptions() {
    return this._options;
  }
}
